export default __webpack_public_path__ + "static/media/jednostavno.981488fa.JPG";